import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Shared UI Library Components
import { CustomButton, CustomIcon, EIconName } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './connect-stripe-notification.scss';

// Store entities
import { getUserState } from '../../../store/user/user.selectors';
import { fetchStipeAccountLink } from '../../../store/company/company.thunks';

type TConnectStripeNotificationProps = {};

export const ConnectStripeNotification: FC<TConnectStripeNotificationProps> = (
  {}: TConnectStripeNotificationProps
) => {

  const [connectingAccount, setConnectingAccount] = useState<boolean>(false);
  const [hiddenMessage, setHiddenMessage] = useState<boolean>(!!sessionStorage.getItem('hide-balance-notification'));

  const { user } = useSelector(getUserState);
  const dispatch = useDispatch<any>();

  const generateStripeLink = async (): Promise<void> => {
    setConnectingAccount(true);
    const { payload: accountLink } = await dispatch(fetchStipeAccountLink({
      // refresh_url: window.origin + '/connect-stripe-account',
      // return_url: window.origin + '/connect-stripe-account',
      refresh_url: window.origin + '/business-profile/payment-details',
      return_url: window.origin + '/business-profile/payment-details',
    }));

    if (!accountLink) {
      setConnectingAccount(false);
      return;
    }
    window.location.assign(accountLink);
  }

  const hideMessageForCurrentSession = (): void => {
    sessionStorage.setItem('hide-balance-notification', 'hide');
    setHiddenMessage(true);
  }

  return (
    <div className="connect-stripe-notification" hidden={ user?.is_stripe_connected === true || !user || hiddenMessage }>
      <div className="connect-stripe-notification--title">
        <CustomIcon name={ EIconName.Info } /> Connect your Stripe Account to start earning
      </div>
      <div className="connect-stripe-notification--action">
        <CustomButton type={ 'text' } size={ 'small' } onClick={ generateStripeLink } loading={ connectingAccount }>
          Connect Stripe Account
        </CustomButton>
      </div>
      <div className="connect-stripe-notification--close" onClick={ hideMessageForCurrentSession }>
        <CustomIcon name={ EIconName.Close }/>
      </div>
    </div>
  );
}
